/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-plusplus */
import { alert, defaultModules, Stack } from '@pnotify/core'
// import '@pnotify/core/dist/PNotify.css';
import _ from 'lodash'
import * as PNotifyMobile from '@pnotify/mobile'
// import '@pnotify/mobile/dist/PNotifyMobile.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as PNotifyFontAwesome4 from '@pnotify/font-awesome4'
import moment from 'moment'
import React from 'react'
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import i18n from '../i18n'
// eslint-disable-next-line import/no-cycle
import { getDataService, postDataService } from '../services/back-end-service'
import { url } from '../services/path-url'
import dateFormat from './dateFormat'

defaultModules.set(PNotifyMobile, {})
defaultModules.set(PNotifyFontAwesome4, {})

export const onSuccess = async (data, genericText = '') => {
  alert({
    type: 'success',
    delay: 3000,
    title: i18n.t('success'),
    text: data?.fault?.faultstring ? data.fault.faultstring : genericText,
    closerHover: false,
    sticker: false,
    stack: new Stack({
      dir1: 'down',
      firstpos1: 75,
    }),
  })
}

export const onErrorTxt = (genericText) => {
  if (genericText) {
    alert({
      type: 'error',
      delay: 3000,
      title: i18n.t('error'),
      text: genericText,
      closerHover: false,
      sticker: false,
      stack: new Stack({
        dir1: 'down',
        firstpos1: 75,
      }),
    })
  }
}

export const onError = (error, genericText = '', sig = true) => {
  if (error && error.fault) {
    alert({
      type: 'error',
      delay: sig ? 3000 : 7000,
      title: i18n.t('error'),
      text: error?.fault?.faultstring ? error.fault.faultstring : genericText,
      closerHover: false,
      sticker: false,
      stack: new Stack({
        dir1: sig ? 'down' : 'right',
        firstpos1: 75,
      }),
    })
  }
}

export const onKeyDownSearch = (e) => {
  if (e.keyCode === 13) {
    e.preventDefault()
  }
}

export const cbOnError = () => {}

export async function getBankDetails(payload, fn, sig) {
  await postDataService(
    payload,
    url.cash.referentiel.open_bic.baseURL,
    fn,
    onError,
    sig
  )
}

export async function checkIban(payload, fn, sig) {
  await postDataService(
    payload,
    url.cash.referentiel.open_bic.baseURL,
    fn,
    onError,
    sig
  )
}

export const loader_element = (
  <div
    style={{
      display: 'block',
    }}
  >
    <div
      style={{
        animation: '400ms linear infinite anim-rotate',
        borderBottom: '2px solid transparent',
        borderLeft: '2px solid #fff',
        borderRadius: '50%',
        borderRight: '2px solid transparent',
        borderTop: '2px solid #fff',
        boxSizing: 'border-box',
        height: 20,
        width: 20,
        marginLeft: 5,
        marginRight: 5,
        display: 'block',
      }}
    />
  </div>
)

export const amountFormat = (x) => {
  if (!x && x !== 0) return ''

  const parts = x.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return parts.join('.')
}

export const roundToDecimals = (num, decimals = 2) => {
  if (!num && num !== 0) return 0
  return Math.round(num * 10 ** decimals) / 10 ** decimals
}

export function CPIAmountDataGrid(value, unit = 2) {
  if (!value && value !== 0) return ''

  const rounded = roundToDecimals(value, unit)

  const fixed = rounded.toFixed(unit)

  return (
    <span style={{ wordSpacing: 1, paddingRight: 2 }}>
      {amountFormat(fixed)}
    </span>
  )
}

// Function for requesting different forms data
export const loadFormData = async (url, success, error, signal) => {
  await getDataService(url, success, error || onError, signal)
}
export const getDateDecalMounth = () => [
  new Date(moment(new Date()).subtract(1, 'M')),
  new Date(moment(new Date()).toLocaleString()),
]
export const colourStyles = {
  indicatorsContainer: (styles) => ({ ...styles, padding: '0px' }),
  control: (styles, state) => ({
    ...styles,
    fontWeight: '400',
    fontSize: '12px',
    minHeight: '30px',
    height: '30px',
    pointerEvents: state.isDisabled ? 'auto' : styles?.pointerEvents,
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    // Styles pour disabled
    ...(state.isDisabled && {
      backgroundColor: '#f8f9fa',
      borderColor: '#dee2e6',
      cursor: 'not-allowed',
      opacity: 1,
      border: 0,
      color: '#212529',
    }),
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    display: state.isDisabled ? 'none' : 'block',
  }),
  indicatorSeparator: (base, state) => ({
    ...base,
    display: state.isDisabled ? 'none' : 'block',
  }),

  singleValue: (styles, state) => ({
    ...styles,
    color: state.isDisabled ? '#212529' : styles.color,
  }),
  option: (styles, { isFocused, isSelected }) => {
    const color = '#EACEB4'
    return {
      ...styles,
      backgroundColor: isSelected ? color : isFocused ? '#E9E2D0' : null,
    }
  },
  menu: (styles) => ({ ...styles, fontWeight: '400', fontSize: '12px' }),
}

export const handleColor = (filter, value) => {
  const tempState =
    filter &&
    filter?.find(
      (el) => el.state === value || el.value == value || el.label == value
    )
  return tempState || ''
}

export const arrayToObject = (arr, key) =>
  arr.reduce((obj, item) => {
    obj[item[key]] = item
    return obj
  }, {})

export const makeOptions = (
  dataParams = [],
  valueKey = 'id',
  labelKey = 'name'
) => {
  try {
    const data = Object.values(dataParams || [])

    if (!Array.isArray(data)) return []

    return data?.map((el) => ({
      ...el,
      label: el?.[labelKey] ?? '',
      value: el?.[valueKey] ?? '',
    }))
  } catch (error) {
    console.error('makeOptions error:', error)
    return []
  }
}

const isEmptyObject = function (obj) {
  return _.isEmpty(obj)
}

export const getObjectDiff = function (obj1, obj2) {
  const result = {}
  let change
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj1) {
    if (typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
      change = getObjectDiff(obj1[key], obj2[key])
      if (isEmptyObject(change) === false) {
        result[key] = change
      }
    } else if (obj2[key] != obj1[key]) {
      result[key] = obj2[key]
    }
  }
  return result
}

export const handleEditMode = (viewMode, stateFourEyes) => {
  if (stateFourEyes === false) {
    if (viewMode === 'view') {
      return false
    }
    return true
  }
  return false
}

export const refactoMontant = (montant) =>
  montant.toLocaleString('fr-FR', { minimumFractionDigits: 2 })

export const downloadPdf = (content, fileName) => {
  const url = `data:application/pdf;base64,${content}`
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadExcel = (content, fileName) => {
  const url = `data:application/excel;base64,${content}`
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
export const downloadFile = (content, fileName, fileType) => {
  const url = `data:application/${fileType};base64,${content}`
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function Loader() {
  return (
    <div
      style={{
        display: 'block',
      }}
    >
      <div
        style={{
          animation: '400ms linear infinite anim-rotate',
          borderBottom: '2px solid transparent',
          borderLeft: '2px solid #fff',
          borderRadius: '50%',
          borderRight: '2px solid transparent',
          borderTop: '2px solid #fff',
          boxSizing: 'border-box',
          height: 20,
          width: 20,
          display: 'block',
        }}
      />
    </div>
  )
}

export const arroundAmount = (nbr) => parseFloat(nbr.toString()).toFixed(2)

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export const reformeFile = (file) => {
  const words = file.split(',')
  return words[1]
}

export const getFileSize = (size) => {
  let sz = size
  const fSExt = ['Bytes', 'KB', 'MB', 'GB']
  let i = 0
  while (sz > 900) {
    sz /= 1024
    i += 1
  }
  const exactSize = `${Math.round(sz * 100) / 100} ${fSExt[i]}`

  return exactSize
}

export const loadFourEyes = async (url, success, error, signal) => {
  await getDataService(url, success, error, signal)
}

export const getArrDifference = (
  array1 = [],
  array2 = [],
  key = 'member_id'
) => {
  try {
    if (!Array.isArray(array1) || !Array.isArray(array2)) return []

    return array1.filter(
      (item1) =>
        !array2.some(
          (item2) => item1?.[key] !== undefined && item1?.[key] === item2?.[key]
        )
    )
  } catch (e) {
    console.error('getArrDifference error:', e)
    return []
  }
}

export const colorMap = (arr, color) =>
  arr
    ?.map((a) => a.member_id)
    // eslint-disable-next-line no-sequences
    .reduce((acc, curr) => ((acc[curr] = color), acc), {})

export const removeEmptyNodes = (arr) =>
  arr.map((obj) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      if (key === 'nodes' && Array.isArray(obj[key]) && obj[key].length === 0) {
        delete obj[key]
      } else if (obj[key] && typeof obj[key] === 'object') {
        obj[key] = removeEmptyNodes(obj[key])
      }
    }
    return obj
  })

export const groupArrayByCode = (arr) => {
  const result = []
  const map = new Map()
  // eslint-disable-next-line no-restricted-syntax
  for (const obj of arr) {
    if (!map.has(obj.account_code)) {
      map.set(obj.account_code, {
        id: Date.now() + Math.floor(Math.random() * 100),
        account_code: obj.account_code,
        amount: 0,
        expanded: true,
        nodes: [],
      })
      result.push(map.get(obj.account_code))
    }

    map.get(obj.account_code).nodes.push({
      ...obj,
      amount: obj.amount,
      id: Date.now() + Math.floor(Math.random() * 10000 + obj.rlvmvt_id),
    })
    map.get(obj.account_code).amount += obj.amount
  }

  const data = result.map((el) => ({
    ...el,
    code: `Nb : ${el.nodes.length}`,
  }))

  return data
}

export const isExistValue = (value) =>
  value &&
  value !== 'false' &&
  value !== 0 &&
  value !== '0' &&
  value !== 'null' &&
  value !== null &&
  value !== 'undefined' &&
  value !== undefined

export const checkRibDoc = (arr) => {
  const hasRibFile = arr.some(
    (obj) => obj.doc_id === 0 && obj.type === '1#OBLI'
  )

  if (hasRibFile) return true
  alert({
    type: 'error',
    delay: 4000,
    title: i18n.t('error'),
    text: i18n.t('message_error_rib'),

    closerHover: false,
    sticker: false,
  })
}

export const updateEndDate = (arr) => {
  const today = new Date().toISOString().slice(0, 10)
  const updatedArray = arr.map((obj) => {
    if (obj.id === 0) {
      return obj
      // eslint-disable-next-line no-else-return
    } else {
      return { ...obj, end_date: today }
    }
  })
  return updatedArray
}

export const nodeLength = (array, len) => {
  // Pour appeler cette fonction, ne passer le parametre len que si vous souhaitez compter que les nodes et l'affecter la valeur 0.
  if (len === undefined) {
    len = array.length
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const e of array) {
    if (e.nodes) {
      len += nodeLength(e.nodes, e.nodes.length)
    }
  }

  return len
}

export const getDataNodes = (
  array,
  namekey = 'id',
  separator = '/',
  root = ''
) => {
  let objResult = {}
  let key
  // eslint-disable-next-line no-restricted-syntax
  for (const e of array) {
    if (e.nodes?.length > 0) {
      key = root + e[namekey]
      objResult[`${key}`] = true
      objResult = {
        ...objResult,
        ...getDataNodes(e.nodes, namekey, separator, `${key + separator}`),
      }
    }
  }
  return objResult
}

export const flat = (tree, child = 'children', res = []) => {
  if (!tree) return []

  if (Array.isArray(tree)) tree = { disable: [], list: tree }

  // eslint-disable-next-line no-restricted-syntax
  for (let a of tree.list) {
    if (!a.e_level) {
      a = {
        ...a,
        e_level: 0,
      }
    }

    const { [child]: node, ...el } = a

    if (!tree.disable.find((e) => e === a.value)) {
      res.push(el)
    }

    if (node) {
      const newTree = {
        disable: tree.disable,
        list: node.map((e) => ({
          ...e,
          e_level: el.e_level + 1,
        })),
      }
      res = flat(newTree, child, res)
    }
  }
  return res
}

export const base64ToBlob = (base64Data, options = undefined) => {
  try {
    const binaryString = window.atob(base64Data)
    const len = binaryString.length
    const bytes = new Uint8Array(len)

    for (let i = 0; i < len; i += 1) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    const blob = new Blob([bytes], options)
    blob.lastModifiedDate = new Date()
    return blob
  } catch (e) {
    return null
  }
}

export const limitedText = (text, limit) =>
  text && text.length > limit ? `${text && text.substring(0, limit)}...` : text

export const isNumber = (txt) => {
  const pattern = /^\d+\.?\d*$/
  return pattern.test(txt)
}

export const floorNumber = (value) => {
  if (value) {
    const floorV = value?.toString()?.replaceAll(' ', '')?.replaceAll(',', '')
    const tempV = Number(floorV)?.toFixed(2)
    return Number(tempV?.trim()) || 0
  }
  return 0
}

export const exportedNotes = (arr) =>
  arr.reduce((result, obj) => {
    if (obj.nodes) {
      result.push(...obj.nodes)
      delete obj.nodes
    }
    result.push(obj)
    return result
  }, [])

export const getAllChildren = (obj) => {
  let children = []

  if (obj.children) {
    children = obj.children
    obj.children.forEach((child) => {
      children = [...children, ...getAllChildren(child)]
    })
  }

  return children
}

export const getAllChildrenInArray = (arr) => {
  const allChildren = []

  arr.forEach((obj) => {
    const children = getAllChildren(obj)
    allChildren.push(...children)
  })

  return allChildren
}

export const numericInputEvent = (event) => {
  const value = event.target.value.replace(',', '.')
  const decimalCount = (value.split('.')[1] || '').length

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return

  // onChange
  if (event.type === 'change') {
    const newValue = decimalCount > 2 ? value.slice(0, -1) : value

    const { data } = event.nativeEvent

    if (data) {
      event.target.value = newValue
    } else {
      event.target.value = parseFloat(newValue)
    }
  }
}

export const numericEditorProps = {
  precision: 2,
  locale: 'en',
  inputProps: { onChange: numericInputEvent },
}

export const handleAmmountTable = (dataS) => {
  const tempDatas =
    dataS &&
    dataS.map((el) => ({
      ...el,
      amount: el.amount.value,
      currency: el.amount.currency,
    }))
  return tempDatas
}

export const isBo = () =>
  window.location.pathname?.startsWith('/bo') ||
  window.localStorage.getItem('super_admin') == 'super_admin'

export const makeConstante = (constants) => {
  const options = []

  Object.keys(constants).forEach((k) => {
    if (k === 'state') {
      options[k] = Object.values(constants[k])
      return
    }
    options[k] = constants[k].map((c) => ({
      ...c,
      value: c.id,
      label: c.name,
    }))
  })

  return options
}
const regex = (expression) => (string) => {
  const reg = new RegExp(expression)
  return reg.test(string)
}
export const isEmail = (email) => {
  const sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]'
  const sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]'
  const sAtom =
    '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+'
  const sQuotedPair = '\\x5c[\\x00-\\x7f]'
  const sDomainLiteral = `\\x5b(${sDtext}|${sQuotedPair})*\\x5d`
  const sQuotedString = `\\x22(${sQtext}|${sQuotedPair})*\\x22`
  const sDomainRef = sAtom
  const sSubDomain = `(${sDomainRef}|${sDomainLiteral})`
  const sWord = `(${sAtom}|${sQuotedString})`
  const sDomain = `${sSubDomain}(\\x2e${sSubDomain})*`
  const sLocalPart = `${sWord}(\\x2e${sWord})*`
  const sAddrSpec = `${sLocalPart}\\x40${sDomain}`
  const sValidEmail = `^${sAddrSpec}$`
  return regex(sValidEmail)(email)
}
export const isObject = (value) =>
  Object.prototype.toString.call(value) === '[object Object]'

export const isString = (value) =>
  Object.prototype.toString.call(value) === '[object String]'

export const exportToJson = (value) => {
  const json = JSON.stringify(value, null, 2)
  const filename = 'data.json'

  const blob = new Blob([json], { type: 'application/json' })
  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = href
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const compareNestedValues = (obj1, obj2, path) => {
  const getPropertyValue = (obj, path) =>
    path.split('.').reduce((acc, key) => acc[key] || '', obj)

  // Obtenir les valeurs des deux objets en utilisant le chemin spécifié
  const value1 = obj1 && getPropertyValue(obj1, path)
  const value2 = obj2 && getPropertyValue(obj2, path)

  // Comparaison des tableaux (number[] ou string[])
  if (Array.isArray(value1) && Array.isArray(value2)) {
    if (value1.length !== value2.length) return false
    return [...value1].sort().join('|') === [...value2].sort().join('|')
  }

  return value1 == value2
}

export const getObjectError = (objet, chemin) => {
  const parties = chemin?.split('.')

  let valeurActuelle = objet

  for (let i = 0; i < parties.length; i++) {
    const partie = parties[i]

    if (valeurActuelle === null || valeurActuelle === undefined) {
      return null
    }

    if (valeurActuelle && valeurActuelle.hasOwnProperty(partie)) {
      valeurActuelle = valeurActuelle[partie]
    } else {
      return null
    }
  }

  return valeurActuelle
}

export const hasDuplicates = (array) => new Set(array).size !== array.length

export const formatIBAN = (iban) => {
  if (iban) {
    // Remove any non-alphanumeric characters from the IBAN
    iban = iban.replace(/[^a-zA-Z0-9]/g, '')
    // Add a space after every 4 characters
    iban = iban.replace(/(.{4})/g, '$1 ')
    // Return the formatted IBAN
    return iban.trim()
  }
}
export const formatBBAN = (val) => val?.replace(/\s+/g, '').toUpperCase()

export const filterIban = (obj, value, key = 'account') => {
  if (value) {
    const ibanCheck = obj?.[key]
    if (ibanCheck) {
      const result = ibanCheck.replace(/\s+/g, '')
      return result.includes(value)
    }

    return false
  }
  return true
}

export const checkRemittanceId = (obj, value) => {
  if (value) {
    const objectRemittanceCheck =
      obj.remittance_id && obj.remittance_id.includes(value)
    const remittanceCheck = (obj.remittance || []).some(
      (remittance) =>
        remittance.remittance_id && remittance.remittance_id.includes(value)
    )
    return objectRemittanceCheck || remittanceCheck
  }
  return true
}

export const checkAra1 = (obj, value) => {
  if (value) {
    const objectRemittanceCheck = value && value?.includes(obj.ara1_state)
    const remittanceCheck = (obj.remittance || []).some(
      (remittance) => value && value?.includes(remittance.ara1_state)
    )
    return objectRemittanceCheck || remittanceCheck
  }
  return true
}

export const filterSmartag = (obj, value) => {
  if (value) {
    const smartList = obj.smartag_list
    if (!Array.isArray(smartList) || !Array.isArray(value)) {
      return false
    }
    return smartList.some((smart) => value.includes(smart?.code))
  }
  return true
}

export const filterAccount = (obj, value) => {
  if (!value || !Array.isArray(value) || value.length === 0) {
    return true
  }

  const accountId = obj?.account_id?.toString()
  if (!accountId) {
    return false
  }

  const stringValues = value.map((item) => item?.toString())
  return stringValues.includes(accountId)
}

export const filterRules = (obj, value) => {
  if (value) {
    const rulesList = obj.rules
    if (!Array.isArray(rulesList) || !Array.isArray(value)) {
      return false
    }
    return rulesList.some((rule) => value.includes(rule?.label))
  }
  return true
}
export const htmlToString = (htmlCode) => {
  if (!regex('</?[^>]+(>|$)')(htmlCode)) return htmlCode
  const div = document.createElement('div')
  div.innerHTML = htmlCode
  return div.textContent || div.innerText || ''
}

export const initializeSelectCustomValues = (customs, config) => {
  const configByIndex = Object.values(config || {}).reduce((acc, field) => {
    if (field?.index) acc[field.index.toString()] = field
    return acc
  }, {})

  return Object.entries(customs || {}).reduce((result, [key, value]) => {
    if (!key.startsWith('customize_')) {
      result[key] = value
      return result
    }

    const inputDateFormats = ['YYYY/MM/DD']

    const fieldIndex = key.replace('customize_', '')
    const fieldConfig = configByIndex[fieldIndex]
    const isSelect = fieldConfig?.field_type === 3
    const isDateValue = fieldConfig?.field_type === 2

    if (isSelect && fieldConfig?.list?.length > 0 && value !== '') {
      const matchingItem = fieldConfig.list.find((item) => item.code === value)
      result[key] = matchingItem
        ? { label: matchingItem.name, value: matchingItem.code }
        : value
    } else if (isDateValue && value != '') {
      const isValidDateFormat = moment(value).isValid(inputDateFormats, true)
      if (isValidDateFormat) {
        result[key] = moment(value).format('YYYY-MM-DD')
      }
    } else {
      result[key] = value
    }

    return result
  }, {})
}

export const convertCustomObject = (obj) => {
  const result = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]

      const isCustoSelect =
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        'label' in value &&
        'value' in value
      if (isCustoSelect) {
        result[key] = value.value
      } else {
        result[key] = value
      }
    }
  }

  return result
}

export const isValidISO8601 = (dateString) => {
  const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}$/
  return iso8601Regex.test(dateString)
}

export const renderCustom = (custom, defaultVisible = false) =>
  custom?.map((el) => ({
    header: el.label,
    minWidth: 150,
    name: `customize_${el.index}`,
    defaultVisible,
    defaultFlex: 1,
    ...(el.field_type === 3 && {
      filterEditor: SelectFilter,
      filterEditorProps: {
        multiple: true,
        wrapMultiple: false,
        dataSource: Object.values(el.list).map((val) => ({
          label: val.name || val.code,
          id: val.code,
        })),
      },
      render: ({ value }) => {
        if (el.field_type == 3) {
          const labelFound = Object.values(el.list)
            .map((val) => ({
              value: val.code,
              label: val.name || val.code,
            }))
            ?.find((f) => f.value == value)
          return labelFound?.label
        }
        return value
      },
    }),
    ...(el.field_type === 4 && {
      textAlign: 'end',
      render: ({ value }) =>
        value !== undefined && Number(value)
          ? CPIAmountDataGrid(Number(value), 2)
          : '',
    }),
    ...(el.field_type == 2 && {
      textAlign: 'center',
      render: ({ value }) => dateFormat.dateAndHour(value, true),
    }),
  })) || []

const CommonMethods = {
  onSuccess,
  onError,
  onKeyDownSearch,
  cbOnError,
  getBankDetails,
  loader_element,
  getDateDecalMounth,
  colourStyles,
  handleColor,
  handleEditMode,
  refactoMontant,
  Loader,
  loadFourEyes,
  removeEmptyNodes,
  groupArrayByCode,
  isExistValue,
  checkRibDoc,
  updateEndDate,
  nodeLength,
  flat,
  base64ToBlob,
}

export default CommonMethods

